import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/download/sec2_phone1.png'
import _imports_1 from '@/assets/img/download/sec2_card.png'
import _imports_2 from '@/assets/img/download/sec2_phone2.png'


const _withScopeId = n => (_pushScopeId("data-v-c4bb19ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "max-w-4xl h-auto mx-auto w-[896px]:px-0 px-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"group1 sm:-translate-x-12\" data-v-c4bb19ee><img src=\"" + _imports_0 + "\" alt=\"\" width=\"100%\" height=\"100%\" class=\"w-full h-full object-contain\" data-v-c4bb19ee></div><div class=\"col2\" data-v-c4bb19ee><img src=\"" + _imports_1 + "\" alt=\"\" width=\"100%\" height=\"100%\" class=\"w-full h-full object-contain\" data-v-c4bb19ee></div><div class=\"group2\" data-v-c4bb19ee><img src=\"" + _imports_2 + "\" alt=\"\" width=\"100%\" height=\"100%\" class=\"w-full h-full object-contain\" data-v-c4bb19ee></div><div class=\"col1 font-medium mb-40 text-lg sm:text-xl sm:leading-relaxed text-center sm:text-left\" data-v-c4bb19ee><p class=\"text-[#3E4044]\" data-v-c4bb19ee>게코, 도마뱀, 뱀, 거북을 비롯해 <br data-v-c4bb19ee> 양서류, 절지류까지 쉽고 빠르게 거래해요.</p></div>", 4)
const _hoisted_6 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBox = _resolveComponent("TitleBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "elRef1",
      class: _normalizeClass(["transition-all duration-1000 w-full opacity-0", _ctx.elClass1])
    }, [
      _createVNode(_component_TitleBox, {
        title: "분양",
        content1: "채팅으로 거래하고",
        content2: "안전하게 결제까지"
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["container mt-10 w-full transition-all duration-1000", _ctx.elClass2]),
      ref: "elRef2"
    }, _hoisted_6, 2)
  ]))
}